<template>
	<section class="highlight-card-row" aria-label="Main">
		<swiper-container
			class="swiper-container"
			:slides-per-view="'auto'"
			:space-between="3"
			:centered-slides="false"
			:free-mode="true"
			:navigation="true"
		>
			<swiper-slide
				v-for="(card, index) in brandBuilderHighlightCards"
				:key="index"
				class="swiper-slide"
			>
				<HighlightCard
					:iconWeight="card.iconWeight"
					:icon="card.icon"
					:title="card.title"
					:description="card.description"
					:backgroundImage="card.backgroundImage"
					:route="card.route"
				/>
			</swiper-slide>
			<FallBack v-if="isLoading" class="spinner-container">
				<LoadingIcon />
			</FallBack>
		</swiper-container>
	</section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import HighlightCard from './HighlightCard.vue';
import FallBack from '@/components/global/FallBack.vue';
import LoadingIcon from '@/components/global/LoadingIcon.vue';

export default {
	name: 'HighlightCardRow',
	components: {
		HighlightCard,
		FallBack,
		LoadingIcon,
	},
	computed: {
		...mapState({
			brandBuilderHighlightCards: (state) =>
				state.banners.brandBuilder.highlightCards,
			isLoading: (state) => state.banners.brandBuilder.loadingStatus,
			error: (state) => state.banners.brandBuilder.error,
		}),
	},
	async created() {
		await this.getBrandBuilderFeatureBanners();
	},
	methods: {
		...mapActions(['getBrandBuilderFeatureBanners']),
	},
};
</script>

<style lang="scss" scoped>
.highlight-card-row {
	@include rem(height, 260px);
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	position: relative;
}

.swiper-container {
	width: 100%;
}

.swiper-slide {
	width: 433px;
}

swiper-container::part(button-next),
swiper-container::part(button-prev) {
	background-color: white;
	width: 45px;
	height: 45px;
	border-radius: 5px;
	padding: 10px;
	box-sizing: border-box;
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
}

.spinner-container {
	width: 100%;
	height: 100%;
}
</style>
